import { render } from "./BaseCarousel.vue?vue&type=template&id=79c1fa93&scoped=true"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"

import "./BaseCarousel.vue?vue&type=style&index=0&id=79c1fa93&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c1fa93"]])

export default __exports__